import { Injectable } from '@angular/core';
import { LinkDefinition } from './server/static-meta-tags-server.service';

@Injectable()
export abstract class StaticMetaTagsService {
  abstract addTag(tag: LinkDefinition): void;
}
